import React from 'react';
import { withTranslation, WithTranslation, TFunction } from 'react-i18next';
import { i18n } from 'i18next';

interface TranslationResourceProps extends WithTranslation {
  message: string;
  parameters?: object;
  i18n: i18n & {
    t: TFunction;
  };
}

class TranslationResource extends React.PureComponent<TranslationResourceProps> {
  render() {
    const { i18n, message, parameters = {} } = this.props;
    return <span>{i18n.t(message, parameters)}</span>;
  }
}

const TranslationResourceWithI18n = withTranslation()(TranslationResource);

export { TranslationResourceWithI18n as TranslationResource };
